<template>
    <b-form-checkbox class="text-nowrap" :disabled="row.Paid" v-model="row.TMSVault">TMS Kasadan Öde</b-form-checkbox>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
export default {
    components:{
        BFormCheckbox
    },
    props:{
        row:Object,
        field:Object
    },
}
</script>

<style>

</style>